module.exports = __webpack_public_path__ + "static/media/insect(21).6d6339b9.PNG";